import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36612 7.63388C6.87796 7.14573 6.87796 6.35427 7.36612 5.86612L11.1161 2.11612C11.6043 1.62796 12.3957 1.62796 12.8839 2.11612L16.6339 5.86612C17.122 6.35427 17.122 7.14573 16.6339 7.63388C16.1457 8.12204 15.3543 8.12204 14.8661 7.63388L13.25 6.01777V21C13.25 21.6904 12.6904 22.25 12 22.25C11.3096 22.25 10.75 21.6904 10.75 21L10.75 6.01777L9.13388 7.63388C8.64573 8.12204 7.85427 8.12204 7.36612 7.63388Z"
        fill={colorValue}
      />
    </svg>
  );
};
